<p-card styleClass="flex">
    <ng-template pTemplate="header">
        <div class="p-3">
            <h2 class="text-xl font-semibold">PPM Payment Stats</h2>
        </div>
    </ng-template>
    <div class="flex flex-col md:flex-row gap-5 items-stretch">
        <div class="w-full md:w-1/2">
            <app-payment-stats-graph></app-payment-stats-graph>
        </div>
        <div class="w-full md:w-1/2">
            <app-payment-progress></app-payment-progress>
        </div>
    </div>
</p-card> 